import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import copilot from '@janus.team/janus-copilot/cjs/janus-copilot';
import Step from './Step';
import { ReactComponent as RackspaceLogo } from '../../../icons/rackspace-r.svg';

import './index.scss';

const Stepper = (props) => {
  const { handleLogout, handleFinished, children } = props;
  const [activeStep, setActiveStep] = useState(0);
  const [stepResults, setStepResult] = useState({});

  const handleActiveStep = (value) => {
    setActiveStep(value);
  };

  const handleStepResults = (result, stepIndex) => {
    setStepResult({
      ...stepResults,
      [stepIndex]: result,
    });
  };

  const handleOnFinish = () => {
    handleFinished(stepResults);
  };

  const stepChildren = React.Children.toArray(children).filter((child) => child.type === Step);
  const steps = React.Children.map(stepChildren, (step, index) => {
    const controlProps = {
      activeStep,
      index,
      active: activeStep === `${index}`,
      completed: activeStep > index,
      pending: activeStep < index,
      last: (index + 1 === stepChildren.length),
      handleActiveStep,
      handleLogout,
      handleOnFinish,
      handleStepResults,
      result: stepResults[index],
      stepResults,
    };
    return React.cloneElement(step, Object.assign(controlProps, step.props));
  });

  const { session: { session: { saml } } } = React.useContext(copilot.context.session);
  const { ddi } = saml;
  const accountName = saml.account_name;
  return (
    <Container>
      <p className="fw-lighter fs-1">Set up Google Cloud Platform</p>
      <div className="stepper__rackspace-account-header">
        <RackspaceLogo color="#eb0000" className="stepper__rackspace-account-header-logo" />
        <div>
          <header className="fw-bold">{accountName}</header>
          <small>{ddi}</small>
        </div>
      </div>
      <Accordion defaultActiveKey="0" className="stepper--vertical" bsPrefix>
        {steps}
      </Accordion>
    </Container>
  );
};

export default Stepper;
